import Treelogy from "./build/Treelogy";
import Version from "./build/Version";
import Node from "./build/Node";
import serialize from "./build/serialize";
import deserialize from "./build/deserialize";

export default Treelogy;
export { Version, Node, serialize, deserialize };



//////////////////
// WEBPACK FOOTER
// ./node_modules/treelogy/index.js
// module id = 326
// module chunks = 0